import React from "react";
import { Helmet } from "react-helmet";
import HeroSection from "./HeroSection";
import MissionSection from "./MissionSection";
import QualitySection from "./QualitySection";
import InfrastructureSection from "./InfrastructureSection";
// import CertificationsSection from "./CertificationsSection";
// import PartnershipsSection from "./PartnershipsSection";

import Footer from "../../components/common/Footer";
import AnviyaFeatures from "../../components/common/AnviyaFeatures";
import { teamMembers } from "./data";
import ContactSection from "../../components/common/ContactSection";

const About = () => {
  return (
    <>
      <Helmet>
        <title>
          ANVIYA Research Lab - Advancing Science Through Ethical Biospecimen
          Services
        </title>
        <meta
          name="description"
          content="ANVIYA Research Lab provides ethical biospecimen services including biofluids, tissue samples, and cells. Leading researchers trust our SOD-driven excellence and fast turnaround."
        />
        <meta
          property="og:title"
          content="ANVIYA Research Lab - Advancing Science Through Ethical Biospecimen Services"
        />
        <meta
          property="og:description"
          content="ANVIYA Research Lab provides ethical biospecimen services including biofluids, tissue samples, and cells. Leading researchers trust our SOD-driven excellence and fast turnaround."
        />
      </Helmet>

      <main className="w-full bg-secondary-background">
        <HeroSection />
        <MissionSection />

        <QualitySection />
        <AnviyaFeatures
          title="The ANVIYA Team"
          features={teamMembers}
          buttonText="Explore Now"
          description="Our multidisciplinary team combines scientific expertise, clinical knowledge, and operational excellence to deliver superior service across both research and diagnostic domains."
        />

        <InfrastructureSection />
        {/* <CertificationsSection />
        <PartnershipsSection /> */}
        <ContactSection />
        <Footer />
      </main>
    </>
  );
};

export default About;
